import {Component, OnDestroy, OnInit} from "@angular/core";
import {ItemPreguntaModelDTO, PreguntaModelDTO} from "@Models";
import {Subscription} from "rxjs";
import {obtenerIdPreguntaTipo, PreguntasTipoEnum} from "@shared/enums";
import {TiposPreguntasService} from "../../tipos-preguntas.service";
import {ItemPreguntaDTO, PreguntaDTO} from "@DTOS";
import {debounceTime, filter, mergeMap, tap} from "rxjs/operators";
import {CommandAsync, ICommand} from "@nahuelmorata/ngx-command";
import {ModalService, NotificacionServiceEmisor} from "@shared/services";
import {
    EditorCondicionesComponent
} from "../../../../encuestas-detalle/editor-condiciones/editor-condiciones.component";
import {TipoPreguntaComponent} from "../tipo-pregunta/tipo-pregunta.component";

@Component({
    templateUrl: "./tipo-pregunta-ranking.component.html",
    styleUrls: ["./tipo-pregunta-ranking.component.scss"]
})
export class TipoPreguntaRankingComponent extends TipoPreguntaComponent implements OnInit, OnDestroy {
    public pregunta = new PreguntaModelDTO(new PreguntaDTO());
    public items: ItemPreguntaModelDTO[] = [];

    public textoItem = "";
    public colores = {};

    public agregarCmd: ICommand = new CommandAsync(() => this.agregarItem());
    public borrarItemCmd: ICommand = new CommandAsync((item: ItemPreguntaModelDTO) =>
        this.borrarItem(item));

    private subsItems = new Subscription();

    constructor(private tiposPreguntasService: TiposPreguntasService, private modalService: ModalService,
        private notificacionService: NotificacionServiceEmisor) {
        super();
    }

    ngOnInit(): void {
        if (this.tiposPreguntasService.preguntaModel != null) {
            this.pregunta = this.tiposPreguntasService.preguntaModel;
        }
        this.colores = this.tiposPreguntasService.colores;
        this.cargarItemsModels();
    }

    ngOnDestroy() {
        this.subsItems.unsubscribe();
    }

    public toggleLimiteMinimo() {
        if (this.pregunta.Minimo != null) {
            this.pregunta.Minimo = null;
        } else {
            this.pregunta.Minimo = 1;
        }
    }

    public toggleLimiteMaximo() {
        if (this.pregunta.Maximo != null) {
            this.pregunta.Maximo = null;
        } else {
            this.pregunta.Maximo = 2;
        }
    }

    public obtenerId(tipoPregunta: PreguntasTipoEnum) {
        return obtenerIdPreguntaTipo(tipoPregunta);
    }

    public abrirEditorCondicionesItem(item: ItemPreguntaModelDTO) {
        const modalRef = this.modalService.open(
            EditorCondicionesComponent, { size: "lg", centered: true, windowClass: "modal-condiciones" }
        );
        const instancia: EditorCondicionesComponent = modalRef.componentInstance;
        instancia.encuesta = this.tiposPreguntasService.encuesta;
        instancia.item = item;
    }

    public clickBorrarItem(item: ItemPreguntaModelDTO) {
        if (this.borrarItemCmd.puedeEjecutarse) {
            this.borrarItemCmd.ejecutar(item);
        }
    }

    private async agregarItem(): Promise<void> {
        let itemPreguntaDTO = new ItemPreguntaDTO({
            text: this.textoItem.trim()
        });

        this.textoItem = "";
        itemPreguntaDTO = await this.tiposPreguntasService.agregarItemPregunta(this.pregunta.Entidad, itemPreguntaDTO);
        const model = this.crearItemModel(itemPreguntaDTO);
        this.items.push(model);
        this.notificacionService.notificarExito("Item agregado correctamente.");
    }

    private cargarItemsModels() {
        this.items = this.pregunta.Items.map(item => this.crearItemModel(item));
    }

    private crearItemModel(item: ItemPreguntaDTO) {
        const model = new ItemPreguntaModelDTO(item);
        this.subsItems.add(
            model.changed$.pipe(
                filter(Boolean),
                filter(() => item.texto !== ""),
                debounceTime(400),
                mergeMap(() => this.tiposPreguntasService.guardarItemPregunta(this.pregunta.Entidad, item)),
                tap(() => this.notificacionService.notificarExito("Item modificado correctamente."))
            ).subscribe()
        );
        return model;
    }

    private async borrarItem(item: ItemPreguntaModelDTO) {
        await this.tiposPreguntasService.borrarItemPregunta(this.pregunta.Entidad, item.Entidad);
        this.subsItems.unsubscribe();
        this.subsItems = new Subscription();
        this.cargarItemsModels();
        this.notificacionService.notificarExito("Item borrado correctamente.");
    }
}
